/* eslint-disable no-use-before-define */
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { AgGridReact } from 'ag-grid-react';
import classnames from 'classnames';
import debounce from 'lodash/debounce';
import SearchBar from '@client-shared/searchBar/searchBar.component';
import { stringifiedSpinner } from '@client-shared/spinner.component';
import { NumberRenderer } from '@client-shared/ui-numeral';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source === null) {
    return {};
  }
  const target = {};
  const sourceKeys = Object.keys(source);
  let key = null;
  let i = 0;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) {
      continue;
    }
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source === null) {
    return {};
  }
  const target = _objectWithoutPropertiesLoose(source, excluded);
  let key;
  let i;

  if (Object.getOwnPropertySymbols) {
    const sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) {
        continue;
      }
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) {
        continue;
      }
      target[key] = source[key];
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  const keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    let symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    // eslint-disable-next-line prefer-spread
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (let i = 1; i < arguments.length; i++) {
    // eslint-disable-next-line prefer-rest-params, eqeqeq
    const source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties(target, props) {
  for (let i = 0; i < props.length; i++) {
    const descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) {
      descriptor.writable = true;
    }
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) {
    _defineProperties(Constructor.prototype, protoProps);
  }

  if (staticProps) {
    _defineProperties(Constructor, staticProps);
  }
  return Constructor;
}

function _assertThisInitialized(self) {
  // eslint-disable-next-line no-void
  if (self === void 0) {
    throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  }

  return self;
}

function _setPrototypeOf(o, p) {
  // eslint-disable-next-line no-func-assign
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true,
    },
  });
  if (superClass) {
    _setPrototypeOf(subClass, superClass);
  }
}

function _getPrototypeOf(o) {
  // eslint-disable-next-line no-func-assign
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) {
    return false;
  }
  if (Reflect.construct.sham) {
    return false;
  }
  if (typeof Proxy === 'function') {
    return true;
  }

  try {
    // eslint-disable-next-line no-empty-function
    Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _typeof(obj) {
  '@babel/helpers - typeof';

  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    // eslint-disable-next-line no-func-assign
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    // eslint-disable-next-line no-func-assign
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
    };
  }

  return _typeof(obj);
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  const hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    // eslint-disable-next-line no-undefined
    const Super = _getPrototypeOf(Derived);
    let result = null;

    if (hasNativeReflectConstruct) {
      const NewTarget = _getPrototypeOf(this).constructor;
      // eslint-disable-next-line prefer-rest-params
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      // eslint-disable-next-line prefer-rest-params
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

const alignLeftCellStyle = {
  cellStyle: {
    textAlign: 'left',
  },
};
const alignRightCellStyle = {
  cellStyle: {
    textAlign: 'right',
  },
};
const alignCenterCellStyle = {
  cellStyle: {
    textAlign: 'center',
  },
};

const AgGridWithCount = /* # __PURE__*/function(_PureComponent) {
  // eslint-disable-next-line no-use-before-define
  _inherits(AgGridWithCount, _PureComponent);

  // eslint-disable-next-line no-use-before-define
  const _super = _createSuper(AgGridWithCount);

  function AgGridWithCount() {
    let _this;

    _classCallCheck(this, AgGridWithCount);

    for (let _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      // eslint-disable-next-line prefer-rest-params
      args[_key] = arguments[_key];
    }

    // eslint-disable-next-line prefer-spread, no-undef, prefer-const
    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), 'state', {
      first: 0,
      last: 0,
      count: 0,
    });

    _defineProperty(_assertThisInitialized(_this), 'updateCount', debounce(function(params) {
      const _params$api$getVertic = params.api.getVerticalPixelRange();
      const top = _params$api$getVertic.top;
      const bottom = _params$api$getVertic.bottom;

      const firstRowId = params.api.getFirstDisplayedRowIndex();
      const lastRowId = params.api.getLastDisplayedRowIndex();
      const displayedRows = Array.from(Array(lastRowId - firstRowId + 1).keys());
      const firstDispayedRow = displayedRows.find(function(id) {
        const index = id + firstRowId;
        const row = params.api.getDisplayedRowAtIndex(index);
        return row.rowTop + row.rowHeight >= top;
      });
      const lastDisplayedRow = displayedRows.sort(function(idA, idB) {
        return idB - idA;
      }).find(function(id) {
        const index = id + firstRowId;
        const row = params.api.getDisplayedRowAtIndex(index);
        return row.rowTop < bottom;
      });

      _this.setState(function() {
        return {
          first: firstDispayedRow + firstRowId + 1 || 0,
          last: lastDisplayedRow + firstRowId + 1 || 0,
          count: params.api.getDisplayedRowCount(),
        };
      });
    }, 100));

    _defineProperty(_assertThisInitialized(_this), 'onBodyScroll', function(params) {
      const onBodyScroll = _this.props.onBodyScroll;

      if (onBodyScroll) {
        onBodyScroll(params);
      }

      _this.updateCount(params);
    });

    _defineProperty(_assertThisInitialized(_this), 'onFilterChanged', function(params) {
      const onFilterChanged = _this.props.onFilterChanged;

      if (onFilterChanged) {
        onFilterChanged(params);
      }

      _this.updateCount(params);
    });

    _defineProperty(_assertThisInitialized(_this), 'onGridReady', function(params) {
      const onGridReady = _this.props.onGridReady;

      if (onGridReady) {
        onGridReady(params);
      }

      _this.updateCount(params);
    });

    _defineProperty(_assertThisInitialized(_this), 'onGridSizeChanged', function(params) {
      const onGridSizeChanged = _this.props.onGridSizeChanged;

      if (onGridSizeChanged) {
        onGridSizeChanged(params);
      }

      _this.updateCount(params);
    });

    _defineProperty(_assertThisInitialized(_this), 'onRowDataUpdated', function(params) {
      const onRowDataUpdated = _this.props.onRowDataUpdated;

      if (onRowDataUpdated) {
        onRowDataUpdated(params);
      }

      _this.updateCount(params);
    });

    return _this;
  }

  _createClass(AgGridWithCount, [{
    key: 'render',
    value: function render() {
      const _this$state = this.state;
      const first = _this$state.first;
      const last = _this$state.last;
      const count = _this$state.count;
      return /* #__PURE__*/React.createElement('div', {
        style: {
          height: '100%',
        },
      }, /* #__PURE__*/React.createElement('div', {
        style: {
          height: 'calc(100% - 40px)',
        },
      }, /* #__PURE__*/React.createElement(AgGridReact, Object.assign({}, this.props, {
        onBodyScroll: this.onBodyScroll,
        onFilterChanged: this.onFilterChanged,
        onGridReady: this.onGridReady,
        onGridSizeChanged: this.onGridSizeChanged,
        onRowDataUpdated: this.onRowDataUpdated,
      }))), /* #__PURE__*/React.createElement('div', {
        className: 'pt-4 text-right grid-count',
      }, /* #__PURE__*/React.createElement('p', null, /* #__PURE__*/React.createElement('span', {
        className: 'font-weight-bold',
      }, first), ' - ', /* #__PURE__*/React.createElement('span', {
        className: 'font-weight-bold',
      }, last), ' of ', /* #__PURE__*/React.createElement('span', {
        className: 'font-weight-bold',
      }, /* #__PURE__*/React.createElement(NumberRenderer, {
        value: count,
      })))));
    },
  }]);

  return AgGridWithCount;
}(PureComponent);

_defineProperty(AgGridWithCount, 'defaultProps', {
  onBodyScroll: null,
  onFilterChanged: null,
  onGridReady: null,
  onGridSizeChanged: null,
  onRowDataUpdated: null,
});

const selectionStateSelector = function selectionStateSelector(_ref) {
  const agGrid = _ref.agGrid;
  return agGrid.agSelectionState;
};
const rowSelectionStateSelector = function rowSelectionStateSelector(_ref2) {
  const agGrid = _ref2.agGrid;
  return agGrid.agRowSelectionState;
};

const SELECT_ROW = '@client-shared/ui-agGrid/SELECT_ROW';
const SELECT_ROW_BY_ROW_INDEX = '@client-shared/ui-agGrid/SELECT_ROW_BY_ROW_INDEX';
const RESET_SELECTION_STATE = '@client-shared/ui-agGrid/RESET_SELECTION_STATE';

const selectRow = function selectRow(_ref) {
  const name = _ref.name;
  const fields = _ref.fields;
  const data = _ref.data;
  const values = fields.reduce(function(result, field) {
    return _objectSpread2(_objectSpread2({}, result), {}, _defineProperty({}, field, data[field]));
  }, {});
  return {
    type: SELECT_ROW,
    payload: {
      name,
      fields,
      values,
    },
  };
};
const selectRowByRowIndex = function selectRowByRowIndex(rowIndex) {
  return {
    type: SELECT_ROW_BY_ROW_INDEX,
    rowIndex,
  };
};
const resetSelectionState = function resetSelectionState() {
  return {
    type: RESET_SELECTION_STATE,
  };
};

const toString = function toString(data) {
  if (data === null) {
    return '';
  }

  if (typeof data === 'boolean' || typeof data === 'number') {
    return data.toString();
  }

  if (typeof data === 'string') {
    return data;
  }

  if (typeof data === 'symbol') {
    throw new TypeError();
  }

  return JSON.stringify(data);
};
const equalNodes = function equalNodes(node, selectionState) {
  return selectionState.fields.every(function(field) {
    return node.data[field] === selectionState.values[field];
  });
};
const compareCollator = new Intl.Collator('en', {
  sensitivity: 'accent',
});
const comparator = function comparator(valueA, valueB) {
  if (typeof valueA === 'undefined' && typeof valueB === 'undefined') {
    return 0;
  }

  if (typeof valueA === 'undefined') {
    return 1;
  }

  if (typeof valueB === 'undefined') {
    return -1;
  }

  if (typeof valueA === 'number' && typeof valueB === 'number') {
    return valueA - valueB;
  }

  const aString = toString(valueA);
  const bString = toString(valueB);
  return compareCollator.compare(aString, bString);
};

const defaultRowHeight = 25;

const getRowHeightBasedOnContent = function getRowHeightBasedOnContent(_ref) {
  const field = _ref.field;
  const margins = _ref.margins;
  const lineHeight = _ref.lineHeight;
  const extraLength = _ref.extraLength;
  const averageCharsInLine = _ref.averageCharsInLine;
  return function(params) {
    return params.data.field ? margins + lineHeight * Math.ceil((params.data[field].length + extraLength)
    / averageCharsInLine) : defaultRowHeight;
  };
};

const excludeFromFilteringColumnProperty = {
  getQuickFilterText: function getQuickFilterText() {
    return '';
  },
};

const sizeColumnsToFit = function sizeColumnsToFit(gridApi, suppressSizeColumnsToFit) {
  if (suppressSizeColumnsToFit) {
    return;
  }

  gridApi.sizeColumnsToFit();
};

const AgGrid = /* #__PURE__*/function(_PureComponent) {
  _inherits(AgGrid, _PureComponent);

  const _super = _createSuper(AgGrid);

  function AgGrid(props) {
    let _this;

    _classCallCheck(this, AgGrid);

    // eslint-disable-next-line prefer-const
    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), 'componentDidUpdate', function(prevProps) {
      if (_this.gridApi) {
        if (prevProps.columnDefs !== _this.props.columnDefs) {
          _this.gridApi.setGridOption('columnDefs', _this.props.columnDefs);

          sizeColumnsToFit(_this.gridApi, _this.props.suppressSizeColumnsToFit);
        }

        if (prevProps.isGridLoading !== _this.props.isGridLoading) {
          let _this$props$rowData;

          if (_this.props.isGridLoading) {
            _this.gridApi.showLoadingOverlay();
          } else if (((_this$props$rowData = _this.props.rowData) === null
            // eslint-disable-next-line no-void
            || _this$props$rowData === void 0 ? void 0 : _this$props$rowData.length) === 0) {
            _this.gridApi.showNoRowsOverlay();
          } else {
            _this.gridApi.hideOverlay();
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), 'componentWillUnmount', function() {
      _this.props.resetSelectionState();
    });

    _defineProperty(_assertThisInitialized(_this), 'componentSizeColumnsToFit', function(params) {
      const suppressSizeColumnsToFit = _this.props.suppressSizeColumnsToFit;
      sizeColumnsToFit(params.api, suppressSizeColumnsToFit);
    });

    _defineProperty(_assertThisInitialized(_this), 'refreshScrollPagination', function(_ref2) {
      const api = _ref2.api;

      if (_this.props.withScrollPagination) {
        const firstRow = api.getFirstDisplayedRowIndex();
        const lastRow = api.getLastDisplayedRowIndex();

        _this.setState({
          firstRow: lastRow < 0 ? 0 : firstRow + 1,
          lastRow: lastRow < 0 ? 0 : lastRow + 1,
          // eslint-disable-next-line no-void
          rowCount: api === null || api === void 0 ? void 0 : api.getDisplayedRowCount(),
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), 'onGridReady', function(params) {
      const _this$props = _this.props;
      const gridSelectionState = _this$props.gridSelectionState;
      const resetSelectionState = _this$props.resetSelectionState;
      const suppressSizeColumnsToFit = _this$props.suppressSizeColumnsToFit;
      _this.gridApi = params.api;
      sizeColumnsToFit(params.api, suppressSizeColumnsToFit);

      if (_this.props.isGridLoading) {
        _this.gridApi.showLoadingOverlay();
      }

      if (gridSelectionState && _this.gridApi) {
        _this.gridApi.forEachNode(function(node) {
          if (equalNodes(node, gridSelectionState)) {
            node.setSelected(true, true);

            _this.gridApi.ensureNodeVisible(node, 'top');

            resetSelectionState();
          }
        });
      }

      if (_this.props.onGridReady) {
        _this.props.onGridReady(params);
      }

      if (_this.props.absoluteScroll) {
        _this.selectRowDebounced = debounce(function() {
          const _this$gridApi$getFocu = _this.gridApi.getFocusedCell();
          const rowIndex = _this$gridApi$getFocu.rowIndex;

          _this.gridApi.getDisplayedRowAtIndex(rowIndex).setSelected(true);
        }, 300);
      }
    });

    _defineProperty(_assertThisInitialized(_this), 'onRowDataUpdated', function(params) {
      _this.gridApi = params.api;

      _this.manageSelectionState(params);

      _this.selectFirstRow(params.api);

      if (_this.props.isGridLoading) {
        params.api.showLoadingOverlay();
      }

      if (_this.props.onRowDataUpdated) {
        _this.props.onRowDataUpdated(params);
      }

      _this.refreshScrollPagination(params);
    });

    _defineProperty(_assertThisInitialized(_this), 'onGridColumnsChanged', function(params) {
      if (_this.props.isGridLoading) {
        params.api.showLoadingOverlay();
      }

      if (_this.props.onGridColumnsChanged) {
        _this.props.onGridColumnsChanged(params);
      }
    });

    _defineProperty(_assertThisInitialized(_this), 'onViewportChanged', function(params) {
      if (_this.props.isGridLoading) {
        params.api.showLoadingOverlay();
      }

      if (_this.props.onViewportChanged) {
        _this.props.onViewportChanged(params);
      }

      _this.refreshScrollPagination(params);
    });

    _defineProperty(_assertThisInitialized(_this), 'onFilterChanged', function(params) {
      if (_this.props.isGridLoading) {
        params.api.showLoadingOverlay();
      }

      if (_this.props.onFilterChanged) {
        _this.props.onFilterChanged(params);
      }

      _this.refreshScrollPagination(params);
    });

    _defineProperty(_assertThisInitialized(_this), 'defaultColumnDefs', _objectSpread2(_objectSpread2({
      menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab'],
      comparator,
      sortable: true,
      filter: true,
      resizable: true,
    }, alignCenterCellStyle), _this.props.defaultColDef));

    _defineProperty(_assertThisInitialized(_this), 'getMainMenuItems', function(params) {
      const mainMenuItemsWithoutToolPanel = params.defaultItems.slice(0, -1);
      return mainMenuItemsWithoutToolPanel;
    });

    _defineProperty(_assertThisInitialized(_this), 'setFilter', function(filter) {
      _this.setState({
        filter,
      });
    });

    _defineProperty(_assertThisInitialized(_this), 'unsetFilter', function() {
      _this.setState({
        filter: '',
      });
    });

    _defineProperty(_assertThisInitialized(_this), 'manageSelectionState', function(_ref3) {
      const api = _ref3.api;
      const _this$props2 = _this.props;
      const gridSelectionState = _this$props2.gridSelectionState;
      const rowSelectionState = _this$props2.rowSelectionState;
      const resetSelectionState = _this$props2.resetSelectionState;
      const suppressSizeColumnsToFit = _this$props2.suppressSizeColumnsToFit;
      sizeColumnsToFit(api, suppressSizeColumnsToFit);

      if (rowSelectionState && _this.gridApi) {
        _this.gridApi.forEachNode(function(node) {
          if (node.rowIndex === rowSelectionState) {
            node.setSelected(true, true);

            _this.gridApi.ensureNodeVisible(node, 'top');

            resetSelectionState();
          }
        });

        return;
      }

      if (gridSelectionState && _this.gridApi) {
        _this.gridApi.forEachNode(function(node) {
          if (equalNodes(node, gridSelectionState)) {
            node.setSelected(true, true);

            _this.gridApi.ensureNodeVisible(node, 'top');

            resetSelectionState();
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), 'selectFirstRow', function(api) {
      if (_this.props.autoSelectFirstRowOnFirstLoad) {
        if (_this.props.rowData.length === 0 || _this.state.dataAlreadyLoadedOnce) {
          return;
        }

        _this.setState({
          dataAlreadyLoadedOnce: true,
        });

        api.forEachNode(function(node) {
          if (node.childIndex === 0) {
            node.setSelected(true, true);
            api.ensureNodeVisible(node, 'top');

            _this.props.resetSelectionState();
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), 'createCustomContextMenu', function(params) {
      return _this.props.createCustomContextMenu ? _this.props.createCustomContextMenu(params) : ['copy', 'copyWithHeaders', 'separator', {
        name: 'Export',
        subMenu: ['csvExport', {
          name: 'Excel Export',
          action: function action() {
            return _this.gridApi.exportDataAsExcel();
          },
        }],
      }];
    });

    _defineProperty(_assertThisInitialized(_this), 'handleKeypress', function(event) {
      if (_this.props.absoluteScroll) {
        const _assertThisInitialize = _assertThisInitialized(_this);
        const gridApi = _assertThisInitialize.gridApi;

        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
          _this.selectRowDebounced();
        }

        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          const visibleColumns = gridApi.getAllDisplayedVirtualColumns().filter(function(column) {
            return !column.pinned;
          });

          if (visibleColumns.length === 0) {
            return;
          }

          const leftmostVisibleColumn = visibleColumns[0];
          const rightmostVisibleColumn = visibleColumns[visibleColumns.length - 1];

          if (event.key === 'ArrowRight') {
            const invisibleColumnOnTheRight = gridApi.getDisplayedColAfter(rightmostVisibleColumn);

            if (invisibleColumnOnTheRight && !invisibleColumnOnTheRight.pinned) {
              gridApi.ensureColumnVisible(invisibleColumnOnTheRight.colId);
            }
          } else {
            const invisibleColumnOnTheLeft = gridApi.getDisplayedColBefore(leftmostVisibleColumn);

            if (invisibleColumnOnTheLeft && !invisibleColumnOnTheLeft.pinned) {
              gridApi.ensureColumnVisible(invisibleColumnOnTheLeft.colId);
            }
          }
        }
      }
    });

    _this.state = {
      filter: props.initialQuickFilterValue,
      dataAlreadyLoadedOnce: false,
      firstRow: 0,
      lastRow: 0,
      rowCount: 0,
    };
    return _this;
  }

  _createClass(AgGrid, [{
    key: 'render',
    value: function render() {
      const _this$props3 = this.props;
      const componentToRenderOnSearchBar = _this$props3.componentToRenderOnSearchBar;
      const messageToRenderOnSearchBar = _this$props3.messageToRenderOnSearchBar;
      const withSearchBar = _this$props3.withSearchBar;
      const SearchBarComponent = _this$props3.SearchBarComponent;
      const disableSearchBar = _this$props3.disableSearchBar;
      const showCount = _this$props3.showCount;
      const allowRowShadowing = _this$props3.allowRowShadowing;
      const isRowShadingEnabled = _this$props3.isRowShadingEnabled;
      const isScrollDisabled = _this$props3.isScrollDisabled;
      const rowData = _this$props3.rowData;
      const withScrollPagination = _this$props3.withScrollPagination;
      const gridProps = _objectWithoutProperties(_this$props3, ['componentToRenderOnSearchBar',
        'messageToRenderOnSearchBar', 'withSearchBar', 'SearchBarComponent', 'disableSearchBar',
        'showCount', 'allowRowShadowing', 'isRowShadingEnabled', 'isScrollDisabled', 'rowData',
        'withScrollPagination']);

      const filter = this.state.filter;
      const searchBarProps = {
        onCancel: this.unsetFilter,
        onSearch: this.setFilter,
        value: filter,
      };
      return /* #__PURE__*/React.createElement('div', {
        className: 'ag-grid-custom',
      }, !withSearchBar ? null : /* #__PURE__*/React.createElement('div', {
        className: 'row',
      }, !componentToRenderOnSearchBar ? null : /* #__PURE__*/React.createElement('div', {
        className: 'col-3',
      }, componentToRenderOnSearchBar), !messageToRenderOnSearchBar ? null : /* #__PURE__*/React.createElement('div', {
        className: 'col-6 ml-auto',
      }, messageToRenderOnSearchBar), SearchBarComponent ? /* #__PURE__*/React.createElement(SearchBar, Object.assign({
        Component: SearchBarComponent,
      }, searchBarProps)) : /* #__PURE__*/React.createElement('div', {
        className: classnames({
          'col-3': Boolean(messageToRenderOnSearchBar),
          'col-5': !messageToRenderOnSearchBar,
          'ml-auto': !messageToRenderOnSearchBar,
        }),
      }, /* #__PURE__*/React.createElement(SearchBar, Object.assign({}, searchBarProps, {
        disabled: disableSearchBar,
      })))), /* #__PURE__*/React.createElement('div', {
        onKeyDown: this.handleKeypress,
        tabIndex: '0',
        className: classnames('ag-theme-bootstrap', {
          'ag-theme-bootstrap-shadowed': allowRowShadowing && isRowShadingEnabled,
        }, {
          'ag-grid-disable-scroll': isScrollDisabled,
        }, {
          'ag-grid-with-scroll-pagination': withScrollPagination,
        }),
      }, showCount ? /* #__PURE__*/React.createElement(AgGridWithCount, Object.assign({
        quickFilterText: filter,
        rowMultiSelectWithClick: true,
        suppressDragLeaveHidesColumns: true,
      }, gridProps, {
        defaultColDef: this.defaultColumnDefs,
        getMainMenuItems: this.getMainMenuItems,
        getContextMenuItems: this.createCustomContextMenu,
        onGridReady: this.onGridReady,
        onRowDataUpdated: this.onRowDataUpdated,
        onGridColumnsChanged: this.onGridColumnsChanged,
        onViewportChanged: this.onViewportChanged,
        onFilterChanged: this.onFilterChanged,
        overlayLoadingTemplate: stringifiedSpinner,
        rowData, // if show withScrollPagination, it should set row buffer as 0, or the number of rows will be added to the value of rowBuffer.
        rowBuffer: withScrollPagination ? 0 : gridProps.rowBuffer,
      })) : /* #__PURE__*/React.createElement(AgGridReact, Object.assign({
        quickFilterText: filter,
        rowMultiSelectWithClick: true,
        suppressDragLeaveHidesColumns: true,
      }, gridProps, {
        defaultColDef: this.defaultColumnDefs,
        getContextMenuItems: this.createCustomContextMenu,
        getMainMenuItems: this.getMainMenuItems,
        onGridReady: this.onGridReady,
        onRowDataUpdated: this.onRowDataUpdated,
        onGridColumnsChanged: this.onGridColumnsChanged,
        onViewportChanged: this.onViewportChanged,
        onFilterChanged: this.onFilterChanged,
        overlayLoadingTemplate: stringifiedSpinner,
        rowData, // if show withScrollPagination, it should set row buffer as 0, or the number of rows will be added to the value of rowBuffer.
        rowBuffer: withScrollPagination ? 0 : gridProps.rowBuffer,
      })), withScrollPagination && /* #__PURE__*/React.createElement('p', {
        className: 'scroll-pagination',
      }, 'Rows: ', /* #__PURE__*/React.createElement('b', null, this.state.firstRow), '-', /* #__PURE__*/React.createElement('b', null, this.state.lastRow), ' of ', /* #__PURE__*/React.createElement('b', null, this.state.rowCount))));
    },
  }]);

  return AgGrid;
}(PureComponent);

_defineProperty(AgGrid, 'defaultProps', {
  headerHeight: 40,
  rowHeight: defaultRowHeight,
  onRowDataUpdated: null,
  onGridColumnsChanged: null,
  rowSelection: 'single',
  showCount: false,
  suppressCellFocus: true,
  withSearchBar: false,
  SearchBarComponent: null,
  disableSearchBar: false,
  allowRowShadowing: false,
  componentToRenderOnSearchBar: null,
  messageToRenderOnSearchBar: null,
  suppressSizeColumnsToFit: false,
  isScrollDisabled: false,
  autoSelectFirstRowOnFirstLoad: false,
  isGridLoading: false,
  absoluteScroll: true,
  isRowShadingEnabled: false,
  initialQuickFilterValue: '',
  withScrollPagination: false,
  onViewportChanged: null,
  onFilterChanged: null,
});

const AgGrid$1 = connect(function(state) {
  return {
    gridSelectionState: selectionStateSelector(state),
    rowSelectionState: rowSelectionStateSelector(state),
  };
}, {
  resetSelectionState,
})(AgGrid);

const initialState = {
  agSelectionState: null,
  agRowSelectionState: null,
};

function agGridReducer() {
  // eslint-disable-next-line prefer-rest-params, no-undefined
  const state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  // eslint-disable-next-line prefer-rest-params, no-undefined
  const action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SELECT_ROW:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        agSelectionState: action.payload,
      });

    case SELECT_ROW_BY_ROW_INDEX:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        agRowSelectionState: action.rowIndex,
      });

    case RESET_SELECTION_STATE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        agSelectionState: null,
        agRowSelectionState: null,
      });

    default:
      return state;
  }
}

export default AgGrid$1;
export { RESET_SELECTION_STATE, SELECT_ROW, SELECT_ROW_BY_ROW_INDEX, alignCenterCellStyle,
  alignLeftCellStyle, alignRightCellStyle, comparator, equalNodes, excludeFromFilteringColumnProperty,
  getRowHeightBasedOnContent, initialState, agGridReducer as reducer, resetSelectionState,
  rowSelectionStateSelector, selectRow, selectRowByRowIndex, selectionStateSelector, sizeColumnsToFit,
  toString };
